export const convertHora = (horaCompleta) => {
  if (horaCompleta.length < 4) {
    horaCompleta =
      "0" + horaCompleta.slice(0, 1) + ":" + horaCompleta.slice(-2);
  } else {
    horaCompleta = horaCompleta.slice(0, 2) + ":" + horaCompleta.slice(-2);
  }
  return horaCompleta;
};
